import { DEFAULT_DECIMAL_DISPLAY_POSITION } from 'app-constants'
import { getPerformanceOverTime } from 'pages/index-details/stats-service'
import { ProductOverview } from 'pages/overview/storage/interface'
import { marketCapNumber } from 'utils'
import { currencyFormat } from '../../utils/formatting-utils'

export interface DisplayData {
  title: string
  text: string
  polarity?: boolean
}
export type ServiceResponse = [] | DisplayData[]
export const indexCardStatisticsService = (productData: ProductOverview): ServiceResponse => {
  const performanceStatistics = getPerformanceOverTime(productData)

  const coreStatistics = [
    {
      title: 'Price',
      text: currencyFormat(productData.basePrice.toFixed(DEFAULT_DECIMAL_DISPLAY_POSITION)),
    },
    {
      title: 'Market cap',
      text: `${marketCapNumber(productData.marketCap.toString(), '$')}`,
    },
  ]

  const getTypeSpecificData = (): DisplayData => {
    return {
      title: '24H',
      text: performanceStatistics.find((item) => item.key === 'lastTwoDays')?.value || '0',
      polarity: true,
    }
  }
  coreStatistics.splice(1, 0, getTypeSpecificData())
  return coreStatistics
}
